import Vue from 'vue';
import router from '@/router';
import store from '@/store';
import App from './App';

// include bootstrap modules
import './setup/bootstrapSetup';
// include validator rules
import './setup/veeValidateSetup';
// include additional
import './setup/additional';

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
